import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from 'react-bootstrap';

import TooltipButton from '../TooltipButton';

const TerminalToolbar = (props) => {
  const {
    selectedId, onAdd, onDetails, onEdit, onDeactivate, onActivate, onDecommission,
  } = props;

  if (selectedId) {
    return (
      <ButtonGroup>
        <TooltipButton variant="info" onClick={onDetails} tooltip="Health Details">
          Details
        </TooltipButton>
        <TooltipButton variant="secondary" onClick={onEdit} tooltip="Edit Terminal">
          Edit
        </TooltipButton>
        {onDeactivate ? (
          <TooltipButton variant="warning" onClick={onDeactivate} tooltip="Deactivate Terminal">
            Deactivate
          </TooltipButton>
        ) : null }
        {onActivate ? (
          <TooltipButton variant="success" onClick={onActivate} tooltip="Activate Terminal">
            Activate
          </TooltipButton>
        ) : null }
        {onDecommission ? (
          <TooltipButton variant="danger" onClick={onDecommission} tooltip="Decommission Terminal">
            Decommission
          </TooltipButton>
        ) : null }
      </ButtonGroup>
    );
  }

  return (
    <ButtonGroup>
      <TooltipButton variant="success" onClick={onAdd} tooltip="Add Terminal">
        Add
      </TooltipButton>
    </ButtonGroup>
  );
};

TerminalToolbar.propTypes = {
  selectedId: PropTypes.number,
  onAdd: PropTypes.func.isRequired,
  onDetails: PropTypes.func.isRequired,
  onActivate: PropTypes.func,
  onDeactivate: PropTypes.func,
  onDecommission: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
};

TerminalToolbar.defaultProps = {
  selectedId: undefined,
  onActivate: undefined,
  onDeactivate: undefined,
  onDecommission: undefined,
};

export default TerminalToolbar;
